import { api } from '@/fsd/shared/api';

export const getPurchaseMissingProductCostDownload = async () => {
  await api.download(`/api/v1/purchase/missing/product_cost/download/`);
};
